export default __webpack_public_path__ + "static/media/galerie6.f284311b.png";